import { Injectable } from '@angular/core';

import { PermissionAliasEnum } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class PermissionsFormService {
    public convertAlias(alias: PermissionAliasEnum): string {
        switch (alias) {
            case PermissionAliasEnum.READ_CONNIE:
            case PermissionAliasEnum.MANAGE_CONNIE:
                return 'Connie';

            case PermissionAliasEnum.READ_FIELD_INTERVENTION:
            case PermissionAliasEnum.MANAGE_FIELD_INTERVENTION:
                return 'intervention';

            case PermissionAliasEnum.MANAGE_EDIT_MODE_CREATE:
            case PermissionAliasEnum.READ_EDIT_MODE_CREATE:
                return 'editMode.create';

            case PermissionAliasEnum.MANAGE_EDIT_MODE_DELETE:
            case PermissionAliasEnum.READ_EDIT_MODE_DELETE:
                return 'editMode.delete';

            case PermissionAliasEnum.MANAGE_EDIT_MODE_UPDATE:
            case PermissionAliasEnum.READ_EDIT_MODE_UPDATE:
                return 'editMode.update';

            case PermissionAliasEnum.READ_FIELD_INTERVENTION_FORM:
            case PermissionAliasEnum.MANAGE_FIELD_INTERVENTION_FORM:
                return 'form';

            case PermissionAliasEnum.READ_DEPOSIT:
            case PermissionAliasEnum.MANAGE_DEPOSIT:
                return 'deposit';

            case PermissionAliasEnum.READ_DOCUMENT:
            case PermissionAliasEnum.MANAGE_DOCUMENT:
                return 'document';

            case PermissionAliasEnum.READ_LAYER:
            case PermissionAliasEnum.MANAGE_LAYER:
                return 'layer';

            case PermissionAliasEnum.READ_MAP_FILTER:
            case PermissionAliasEnum.MANAGE_MAP_FILTER:
                return 'mapFilter.title';

            case PermissionAliasEnum.READ_PERSON:
            case PermissionAliasEnum.MANAGE_PERSON:
                return 'user';

            case PermissionAliasEnum.READ_PIN:
            case PermissionAliasEnum.MANAGE_PIN:
                return 'pin.title';

            case PermissionAliasEnum.READ_PROJECT:
            case PermissionAliasEnum.MANAGE_PROJECT:
                return 'project';

            case PermissionAliasEnum.READ_ROLE:
            case PermissionAliasEnum.MANAGE_ROLE:
                return 'role';

            case PermissionAliasEnum.READ_SERVICE_CATALOG:
            case PermissionAliasEnum.MANAGE_SERVICE_CATALOG:
                return 'serviceCatalog';

            case PermissionAliasEnum.READ_STATISTIC:
            case PermissionAliasEnum.MANAGE_STATISTIC:
                return 'statistics';

            case PermissionAliasEnum.READ_SYNOPTIC:
            case PermissionAliasEnum.MANAGE_SYNOPTIC:
                return 'synoptic.title';

            case PermissionAliasEnum.READ_GOOGLE_STREET_VIEW:
                return 'Google Street View';

            default:
                return '';
        }
    }
}
